import React from 'react';
import { StyledSpacing } from '../index.styled';
import {
  StyledContainer,
  StyledLogo,
  StyledLogoLink,
  StyledLogoWithMarginTop,
  StyledSubtitle,
  StyledSupportersWrapper,
  StyledTitle,
  StyledTitleWrapper,
} from './index.styled';

import arasDigital from 'assets/visuals/internship/supporters/aras-digital.png';
import blank from 'assets/visuals/internship/supporters/blank.png';
import codemage from 'assets/visuals/internship/supporters/codemage.svg';
import endava from 'assets/visuals/internship/supporters/endava.svg';
import FESB from 'assets/visuals/internship/supporters/FESB.png';
import townSplit from 'assets/visuals/internship/supporters/grad-split.png';
import infobip from 'assets/visuals/internship/supporters/infobip.svg';
import kazinotiKomenda from 'assets/visuals/internship/supporters/kazinoti-komenda.svg';
import mkc from 'assets/visuals/internship/supporters/mkc.png';
import netmedia from 'assets/visuals/internship/supporters/netmedia.png';
import profico from 'assets/visuals/internship/supporters/profico.png';
import SCST from 'assets/visuals/internship/supporters/SCST.svg';
import seekAndHit from 'assets/visuals/internship/supporters/seek-and-hit.png';
import studion from 'assets/visuals/internship/supporters/studion.svg';
import universityOfSplit from 'assets/visuals/internship/supporters/sveuciliste-u-splitu.svg';
import SZST from 'assets/visuals/internship/supporters/SZST.png';

const ReasonsToBecomeAMember = () => {
  return (
    <StyledSpacing>
      <StyledContainer>
        <StyledTitleWrapper>
          <StyledTitle>Podržavaju nas</StyledTitle>
          <StyledSubtitle>
            Kroz gostujuća predavanja, radionice i job shadowing imaš priliku zaviriti u poslovni svijet te se
            informirati o tome koje tvrtke djeluju u lokalnoj IT zajednici, na kakvim projektima rade i koji su uvjeti
            za zaposlenje kod njih.
          </StyledSubtitle>
        </StyledTitleWrapper>
        <StyledSupportersWrapper>
          <StyledLogoLink target="_blank" href="https://blankhq.co/">
            <StyledLogo src={blank} alt="Blank" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="https://infobip.com/">
            <StyledLogo src={infobip} width={160} alt="Infobip" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="https://gostudion.com/">
            <StyledLogo src={studion} width={100} alt="Studion" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="https://netmedia.hr/">
            <StyledLogo src={netmedia} alt="Netmedia" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="https://www.kazinotikomenda.com/">
            <StyledLogo src={kazinotiKomenda} alt="Kazinoti&Komenda" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="https://www.codemage.co/">
            <StyledLogo src={codemage} width={160} alt="CodeMage" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="https://www.endava.com/">
            <StyledLogo src={endava} width={160} alt="Endava" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="https://profi.co/">
            <StyledLogo src={profico} alt="Profico" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="https://seekandhit.com/hr/">
            <StyledLogo src={seekAndHit} alt="Seek and Hit" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="https://arasdigital.co/">
            <StyledLogo src={arasDigital} alt="Aras Digital Products" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="https://www.scst.unist.hr/">
            <StyledLogo src={SCST} alt="Studentski centar Split" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="https://split.hr/">
            <StyledLogo src={townSplit} width={140} alt="Grad Split" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="https://www.fesb.unist.hr/">
            <StyledLogoWithMarginTop margin="38px" src={FESB} alt="FESB" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="https://www.unist.hr/">
            <StyledLogoWithMarginTop margin="28px" src={universityOfSplit} alt="Sveučilište u Splitu" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="http://www.szst.unist.hr/">
            <StyledLogoWithMarginTop src={SZST} width={150} alt="Studentski zbor sveučilišta u Splitu" />
          </StyledLogoLink>
          <StyledLogoLink target="_blank" href="http://mkcsplit.hr/">
            <StyledLogoWithMarginTop src={mkc} alt="Dom Mladih Split" />
          </StyledLogoLink>
        </StyledSupportersWrapper>
      </StyledContainer>
    </StyledSpacing>
  );
};

export default ReasonsToBecomeAMember;
